var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPentagonShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1998 3.39385L20.2328 8.63085C20.572 8.8833 20.8225 9.23677 20.9483 9.64049C21.074 10.0442 21.0686 10.4774 20.9328 10.8779L17.9598 19.6419C17.8256 20.0378 17.5707 20.3817 17.231 20.6252C16.8913 20.8688 16.4838 20.9998 16.0658 20.9999H7.94575C7.52487 21 7.11465 20.8674 6.77351 20.6209C6.43238 20.3744 6.1777 20.0265 6.04575 19.6269L3.14975 10.8619C3.01859 10.4648 3.01519 10.0366 3.14004 9.63746C3.26488 9.23834 3.51169 8.8884 3.84575 8.63685L10.8038 3.39985C11.1497 3.14092 11.5702 3.00098 12.0023 3.00098C12.4344 3.00098 12.8548 3.14092 13.2008 3.39985L13.1998 3.39385Z",
    fill: "#52BFA4",
    stroke: "#52BFA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPentagonShape);
export default __webpack_public_path__ + "static/media/pentagon-shape.866be60f859ec33001e2168c3949cbcc.svg";
export { ForwardRef as ReactComponent };